import Vue from "vue";
export default {
  getEssPayslipReport(_, reportParams) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(
          `/payroll/reports/me/payslips
        `,
          reportParams
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
